var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',[_c('v-content',[_c('v-container',[_c('v-row',[_c('v-col',[_c('div',{staticClass:"text-center"},[_c('h1',[_vm._v(" 指定頂いたページは見つかりません。 "),_c('br'),_vm._v("お手数ではございますが、再度メニューをご選択ください ")])])])],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }